import Vue from 'vue'
import App from './App'
import Api from '../http/api.js'
import localStorage from '../http/localStorage.js'
import router from './router'
import ElementUI from 'element-ui';
import Swiper, { Autoplay } from "swiper";
Swiper.use([Autoplay]);
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import "swiper/swiper.min.css"

Vue.use(ElementUI);
Vue.prototype.$swiper = Swiper
Vue.prototype.$api = Api
Vue.prototype.$localStorage = localStorage
Vue.config.productionTip = false

new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js